import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UsersService } from '../services/users.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private usersService: UsersService
    ) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if(this.usersService.user) return true;

        return this.usersService.validateToken()
        .pipe(map((hasRole) => {
            if(!hasRole) this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url.split('?')[0] } });
            return hasRole;
        }));
    }

}